





































import Vue from 'vue';
import UserRegisterRequestViewModel from '../../../services/v1/viewModel/resource/UserRegisterRequestViewModel';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    passwordValidationMessage: undefined as string | undefined,
    newUserModel: new UserRegisterRequestViewModel(),
    linkError: undefined as string | undefined,
  }),
  methods: {
    async createUser() {
      this.passwordValidationMessage = undefined;
      const minLength = this.$config.values['auth-min-password-length'] ?? 0;
      if (!this.newUserModel?.password || this.newUserModel?.password?.length < minLength) {
        this.passwordValidationMessage = this.$t('core.validation.minLength', minLength);
        return;
      }
      // A hostadmin does not need to verify
      // Just show clear text and keep it simple
      this.newUserModel.passwordRepeat = this.newUserModel.password;
      this.$service.api.core.users.registerHostadmin(this.newUserModel)
        .then((id: any) => {
          Vue.$router.replace(`/_admin/users/${id}`);
        })
        .catch((error: any) => {
          this.linkError = error;
        });
    },
  },
});
